import PortalIdParser from 'PortalIdParser';
export const getAudiencesDashboardUrl = () => `/audiences/${PortalIdParser.get()}`;
export const getAudienceDetailsUrl = audienceId => `/audiences/${PortalIdParser.get()}/details/${audienceId}`;